<template>
  <div
    class="scroll-button"
    @click="scrollTo()"
    v-if="screenHeight <= lessHeightWillShow"
  >
    <span class="mr-5">{{
      isBottom ? $t('text.top') : $t('text.quick_actions')
    }}</span>
    <i :class="isBottom ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isBottom: false,
      screenHeight: window.innerHeight
    }
  },
  props: {
    lessHeightWillShow: {
      type: Number,
      default: 650
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
    window.addEventListener('resize', () => {
      this.screenHeight = window.innerHeight
    })
  },
  methods: {
    scrollTo() {
      if (this.isBottom) {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
      } else {
        let element = document.getElementById('quick-actions')
        element.scrollIntoView({
          behavior: 'smooth'
        })
      }
    },
    handleScroll() {
      let scrollTop = document.documentElement.scrollTop
      let clientHeight = document.documentElement.clientHeight
      let scrollHeight = document.documentElement.scrollHeight
      this.isBottom = scrollTop + clientHeight === scrollHeight
    }
  }
}
</script>
